import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const DEFAULTS = { brand_name: "FiberPass", brand_accent: "", brand_bg: "", brand_theme: "dark", logo_data_url: "" };

const BrandingContext = createContext(null);

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(DEFAULTS);

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/public/branding");
      setBranding({ ...DEFAULTS, ...data });
    } catch { /* keep defaults */ }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  useEffect(() => {
    const root = document.documentElement;
    if (branding.brand_accent) root.style.setProperty("--brand-accent", branding.brand_accent);
    else root.style.removeProperty("--brand-accent");
    if (branding.brand_bg) root.style.setProperty("--brand-bg", branding.brand_bg);
    else root.style.removeProperty("--brand-bg");
    const th = branding.brand_theme === "light" ? "light" : "dark";
    root.classList.remove("light", "dark");
    root.classList.add(th);
  }, [branding.brand_accent, branding.brand_bg, branding.brand_theme]);

  return (
    <BrandingContext.Provider value={{ branding, reload }}>
      {children}
    </BrandingContext.Provider>
  );
}

export const useBranding = () =>
  useContext(BrandingContext) || { branding: DEFAULTS, reload: () => {} };
